import React, { ReactElement } from 'react';

import { CommonPropType } from 'components/generic-question/index.story';

import { DatePicker } from '..';

export const DatePickerStory = (props: CommonPropType): ReactElement => (
  <DatePicker
    date={new Date(0)}
    onDateChange={console.log}
    highlight={props.highlight}
  />
);
